import { literalParamWithDefault, parseableSearchSchema } from "@crm/effect/schema/search";
import { Schema } from "effect";

const studentDetailTabs = [
  "enrollments",
  "accounts",
  "orders",
  "chat",
  "progress-updates",
  "media",
  "sites",
  "inquiry-proofs",
  "content-topics",
  "praises",
] as const;

const optionalNumberParam = Schema.optional(Schema.Union([Schema.Finite, Schema.FiniteFromString]));

export const studentDetailSearchSchema = parseableSearchSchema(
  Schema.Struct({
    // tab 有固定默认值：fallback + default
    tab: literalParamWithDefault(studentDetailTabs, "enrollments"),

    // 聊天分页：可选（仅 chat tab 使用）
    chatPage: optionalNumberParam,
  }),
);

export type StudentDetailSearch = Schema.Schema.Type<typeof studentDetailSearchSchema>;
